import React, { useState, useEffect } from 'react';
import { serviceWorkerService } from '../services/serviceWorkerService';

const UpdateNotification = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    // Listen for update notifications
    const unsubscribe = serviceWorkerService.addUpdateListener(setUpdateAvailable);
    
    // Check if update is already available
    setUpdateAvailable(serviceWorkerService.isUpdateReady());

    return unsubscribe;
  }, []);

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      await serviceWorkerService.update();
      // The page will reload automatically when the new SW takes control
    } catch (error) {
      console.error('Failed to update:', error);
      setIsUpdating(false);
    }
  };

  const handleDismiss = () => {
    setUpdateAvailable(false);
  };

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-blue-600 text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-4 max-w-md">
        <div className="flex-1">
          <div className="font-semibold mb-1">Update Available</div>
          <div className="text-sm text-blue-100">
            A new version of EZ Bookmarks is ready to install.
          </div>
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={handleUpdate}
            disabled={isUpdating}
            className="bg-white text-blue-600 px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isUpdating ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                Updating...
              </div>
            ) : (
              'Update'
            )}
          </button>
          
          <button
            onClick={handleDismiss}
            className="text-blue-100 hover:text-white p-2 rounded-md transition-colors"
            title="Dismiss"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
